<template>
  <div class="context-footer-rm">
    <template
    v-if="manipulation !== null"
    >
      <span class="activity-label">{{$t('general.created_at')}}: </span>
      <b>{{ manipulation.createdAt | unixTStoDateTime($i18n.locale) }}</b>
      {{ manipulation.createdBy != null ? ` ${$t('general.by')} ${manipulation.createdBy}` : '' }} <br>
      <span class="activity-label">{{$t('general.last_update')}}: </span>
      <b>{{ manipulation.lastUpdateAt | unixTStoDateTime($i18n.locale) }}</b>
      {{ manipulation.lastUpdateBy != null ? ` ${$t('general.by')} ${manipulation.lastUpdateBy}` : '' }}
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ContextFooterRM',
  props: {
    selectedView: { type: String, default: null }
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getSelectedResourceSecond'
    ]),
    manipulation () {
      let source = null
      if (this.getSelectedResourceSecond !== null && this.selectedView !== 'overview') {
        if (this.getSelectedResourceSecond.resourceModifier !== undefined) {
          source = this.getSelectedResourceSecond.resourceModifier
        } else {
          return null
        }
      } else if (this.getSelectedResource !== null && this.getSelectedResource.resourceModifier !== undefined && this.selectedView === 'overview') {
        source = this.getSelectedResource.resourceModifier
      } else {
        return null
      }
      return {
        createdAt: source.createdAt,
        createdBy: source.createdBy,
        lastUpdateAt: source.lastUpdateAt,
        lastUpdateBy: source.lastUpdateBy
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .context-footer-rm {
    padding: 6px 10px 0 10px;
    border-top: 1px solid lightgray;
    background-color: #fafafa;
    height: 100%;
    font-size: 14px;
  }

</style>
